import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
import VueAxios from "vue-axios";

Vue.use(Vuex, axios, VueAxios);

export default new Vuex.Store({
  state: {
    categories: [
      {name: 'akt', title: 'Erotik & Akt'},
      {name: 'hochzeiten', title: 'Hochzeiten & Feiern'},
      {name: 'landschaften', title: 'Landschaften'},
      {name: 'buildings', title: 'Gebäude'},
      {name: 'portraits', title: 'Menschen + Portraits'},
      {name: 'action', title: 'Light- & Actionfotografie'},
      {name: 'tiere', title: 'Tiere'},
      {name : 'makro', title: 'Makro'},
      {name: 'produkte', title: 'Produkte'},
      {name: 'lowlight', title: 'Lowlight'},
      {name: 'rooms', title: 'Räume & Immobilien'},
      {name: 'babies', title: 'Babys'}

    ],
    akt: {
      details: [
        'https://wernicke-foto.de/bilder/original/akt/01.jpg',
        'https://wernicke-foto.de/bilder/original/akt/02.jpg',
        'https://wernicke-foto.de/bilder/original/akt/03.jpg',
        'https://wernicke-foto.de/bilder/original/akt/04.jpg',
        'https://wernicke-foto.de/bilder/original/akt/05.jpg',
        'https://wernicke-foto.de/bilder/original/akt/06.jpg',
        'https://wernicke-foto.de/bilder/original/akt/07.jpg',
        'https://wernicke-foto.de/bilder/original/akt/08.jpg',
        'https://wernicke-foto.de/bilder/original/akt/09.jpg',
        'https://wernicke-foto.de/bilder/original/akt/10.jpg',
        'https://wernicke-foto.de/bilder/original/akt/11.jpg',
        'https://wernicke-foto.de/bilder/original/akt/12.jpg',
        'https://wernicke-foto.de/bilder/original/akt/13.jpg',
        'https://wernicke-foto.de/bilder/original/akt/14.jpg',
        'https://wernicke-foto.de/bilder/original/akt/15.jpg',
        'https://wernicke-foto.de/bilder/original/akt/16.jpg',
        'https://wernicke-foto.de/bilder/original/akt/17.jpg',
        'https://wernicke-foto.de/bilder/original/akt/18.jpg',
        'https://wernicke-foto.de/bilder/original/akt/19.jpg',
        'https://wernicke-foto.de/bilder/original/akt/20.jpg',
      ],
      thumbnails: [
        'https://wernicke-foto.de/bilder/300x300/akt/01.jpg',
        'https://wernicke-foto.de/bilder/300x300/akt/02.jpg',
        'https://wernicke-foto.de/bilder/300x300/akt/03.jpg',
        'https://wernicke-foto.de/bilder/300x300/akt/04.jpg',
        'https://wernicke-foto.de/bilder/300x300/akt/05.jpg',
        'https://wernicke-foto.de/bilder/300x300/akt/06.jpg',
        'https://wernicke-foto.de/bilder/300x300/akt/07.jpg',
        'https://wernicke-foto.de/bilder/300x300/akt/08.jpg',
        'https://wernicke-foto.de/bilder/300x300/akt/09.jpg',
        'https://wernicke-foto.de/bilder/300x300/akt/10.jpg',
        'https://wernicke-foto.de/bilder/300x300/akt/11.jpg',
        'https://wernicke-foto.de/bilder/300x300/akt/12.jpg',
        'https://wernicke-foto.de/bilder/300x300/akt/13.jpg',
        'https://wernicke-foto.de/bilder/300x300/akt/14.jpg',
        'https://wernicke-foto.de/bilder/300x300/akt/15.jpg',
        'https://wernicke-foto.de/bilder/300x300/akt/16.jpg',
        'https://wernicke-foto.de/bilder/300x300/akt/17.jpg',
        'https://wernicke-foto.de/bilder/300x300/akt/18.jpg',
        'https://wernicke-foto.de/bilder/300x300/akt/19.jpg',
        'https://wernicke-foto.de/bilder/300x300/akt/20.jpg',
      ],
      previews: [
        'https://wernicke-foto.de/bilder/400x400/akt/01.jpg',
        'https://wernicke-foto.de/bilder/400x400/akt/02.jpg',
        'https://wernicke-foto.de/bilder/400x400/akt/03.jpg',
        'https://wernicke-foto.de/bilder/400x400/akt/04.jpg',
        'https://wernicke-foto.de/bilder/400x400/akt/05.jpg',
        'https://wernicke-foto.de/bilder/400x400/akt/06.jpg',
        'https://wernicke-foto.de/bilder/400x400/akt/07.jpg',
        'https://wernicke-foto.de/bilder/400x400/akt/08.jpg',
        'https://wernicke-foto.de/bilder/400x400/akt/09.jpg',
        'https://wernicke-foto.de/bilder/400x400/akt/10.jpg',
        'https://wernicke-foto.de/bilder/400x400/akt/11.jpg',
        'https://wernicke-foto.de/bilder/400x400/akt/12.jpg',
        'https://wernicke-foto.de/bilder/400x400/akt/13.jpg',
        'https://wernicke-foto.de/bilder/400x400/akt/14.jpg',
        'https://wernicke-foto.de/bilder/400x400/akt/15.jpg',
        'https://wernicke-foto.de/bilder/400x400/akt/16.jpg',
        'https://wernicke-foto.de/bilder/400x400/akt/17.jpg',
        'https://wernicke-foto.de/bilder/400x400/akt/18.jpg',
        'https://wernicke-foto.de/bilder/400x400/akt/19.jpg',
        'https://wernicke-foto.de/bilder/400x400/akt/20.jpg',
      ]
    },
    hochzeiten : {
details: [
        'https://wernicke-foto.de/bilder/original/hochzeiten/01.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/02.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/03.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/04.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/05.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/06.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/07.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/08.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/09.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/10.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/11.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/12.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/13.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/14.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/15.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/16.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/17.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/18.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/19.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/20.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/21.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/22.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/23.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/24.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/25.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/26.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/27.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/28.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/29.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/30.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/31.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/32.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/33.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/34.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/35.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/36.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/37.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/38.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/39.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/40.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/41.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/42.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/43.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/44.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/45.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/46.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/47.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/48.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/49.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/50.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/51.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/52.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/53.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/54.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/55.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/56.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/57.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/58.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/59.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/60.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/61.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/62.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/63.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/64.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/65.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/66.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/67.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/68.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/69.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/70.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/71.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/72.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/73.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/74.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/75.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/76.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/77.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/78.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/79.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/80.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/81.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/82.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/83.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/84.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/85.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/86.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/87.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/88.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/89.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/90.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/91.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/92.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/93.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/94.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/95.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/96.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/97.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/98.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/99.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/100.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/101.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/102.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/103.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/104.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/105.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/106.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/107.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/108.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/109.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/110.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/111.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/112.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/113.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/114.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/115.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/116.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/117.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/118.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/119.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/120.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/121.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/122.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/123.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/124.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/125.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/126.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/127.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/128.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/129.jpg',
        'https://wernicke-foto.de/bilder/original/hochzeiten/130.jpg',
      ],
      thumbnails: [
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/01.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/02.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/03.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/04.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/05.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/06.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/07.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/08.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/09.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/10.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/11.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/12.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/13.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/14.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/15.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/16.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/17.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/18.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/19.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/20.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/21.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/22.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/23.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/24.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/25.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/26.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/27.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/28.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/29.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/30.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/31.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/32.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/33.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/34.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/35.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/36.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/37.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/38.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/39.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/40.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/41.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/42.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/43.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/44.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/45.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/46.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/47.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/48.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/49.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/50.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/51.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/52.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/53.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/54.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/55.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/56.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/57.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/58.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/59.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/60.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/61.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/62.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/63.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/64.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/65.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/66.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/67.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/68.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/69.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/70.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/71.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/72.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/73.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/74.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/75.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/76.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/77.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/78.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/79.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/80.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/81.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/82.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/83.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/84.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/85.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/86.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/87.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/88.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/89.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/90.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/91.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/92.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/93.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/94.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/95.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/96.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/97.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/98.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/99.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/100.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/101.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/102.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/103.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/104.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/105.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/106.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/107.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/108.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/109.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/110.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/111.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/112.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/113.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/114.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/115.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/116.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/117.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/118.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/119.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/120.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/121.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/122.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/123.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/124.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/125.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/126.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/127.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/128.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/129.jpg',
        'https://wernicke-foto.de/bilder/300x300/hochzeiten/130.jpg',
      ],
      previews: [
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/01.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/02.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/03.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/04.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/05.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/06.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/07.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/08.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/09.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/10.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/11.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/12.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/13.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/14.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/15.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/16.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/17.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/18.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/19.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/20.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/21.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/22.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/23.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/24.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/25.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/26.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/27.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/28.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/29.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/30.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/31.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/32.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/33.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/34.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/35.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/36.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/37.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/38.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/39.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/40.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/41.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/42.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/43.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/44.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/45.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/46.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/47.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/48.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/49.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/50.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/51.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/52.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/53.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/54.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/55.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/56.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/57.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/58.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/59.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/60.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/61.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/62.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/63.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/64.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/65.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/66.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/67.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/68.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/69.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/70.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/71.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/72.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/73.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/74.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/75.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/76.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/77.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/78.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/79.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/80.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/81.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/82.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/83.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/84.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/85.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/86.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/87.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/88.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/89.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/90.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/91.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/92.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/93.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/94.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/95.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/96.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/97.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/98.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/99.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/100.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/101.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/102.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/103.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/104.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/105.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/106.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/107.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/108.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/109.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/110.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/111.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/112.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/113.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/114.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/115.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/116.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/117.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/118.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/119.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/120.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/121.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/122.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/123.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/124.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/125.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/126.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/127.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/128.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/129.jpg',
        'https://wernicke-foto.de/bilder/400x400/hochzeiten/130.jpg',        
      ]
    },
    landschaften: {
      details: [
        'https://wernicke-foto.de/bilder/original/landschaften/01.jpg',
        'https://wernicke-foto.de/bilder/original/landschaften/02.jpg',
        'https://wernicke-foto.de/bilder/original/landschaften/03.jpg',
        'https://wernicke-foto.de/bilder/original/landschaften/04.jpg',
        'https://wernicke-foto.de/bilder/original/landschaften/05.jpg',
        'https://wernicke-foto.de/bilder/original/landschaften/06.jpg',
        'https://wernicke-foto.de/bilder/original/landschaften/07.jpg',
        'https://wernicke-foto.de/bilder/original/landschaften/08.jpg',
        'https://wernicke-foto.de/bilder/original/landschaften/09.jpg',
        'https://wernicke-foto.de/bilder/original/landschaften/10.jpg',
        'https://wernicke-foto.de/bilder/original/landschaften/11.jpg',
        'https://wernicke-foto.de/bilder/original/landschaften/12.jpg',
        'https://wernicke-foto.de/bilder/original/landschaften/13.jpg',
        'https://wernicke-foto.de/bilder/original/landschaften/14.jpg',
        'https://wernicke-foto.de/bilder/original/landschaften/15.jpg',
        'https://wernicke-foto.de/bilder/original/landschaften/16.jpg',
        'https://wernicke-foto.de/bilder/original/landschaften/17.jpg',
        'https://wernicke-foto.de/bilder/original/landschaften/18.jpg',
        'https://wernicke-foto.de/bilder/original/landschaften/19.jpg',
      ],
      thumbnails: [
        'https://wernicke-foto.de/bilder/300x300/landschaften/01.jpg',
        'https://wernicke-foto.de/bilder/300x300/landschaften/02.jpg',
        'https://wernicke-foto.de/bilder/300x300/landschaften/03.jpg',
        'https://wernicke-foto.de/bilder/300x300/landschaften/04.jpg',
        'https://wernicke-foto.de/bilder/300x300/landschaften/05.jpg',
        'https://wernicke-foto.de/bilder/300x300/landschaften/06.jpg',
        'https://wernicke-foto.de/bilder/300x300/landschaften/07.jpg',
        'https://wernicke-foto.de/bilder/300x300/landschaften/08.jpg',
        'https://wernicke-foto.de/bilder/300x300/landschaften/09.jpg',
        'https://wernicke-foto.de/bilder/300x300/landschaften/10.jpg',
        'https://wernicke-foto.de/bilder/300x300/landschaften/11.jpg',
        'https://wernicke-foto.de/bilder/300x300/landschaften/12.jpg',
        'https://wernicke-foto.de/bilder/300x300/landschaften/13.jpg',
        'https://wernicke-foto.de/bilder/300x300/landschaften/14.jpg',
        'https://wernicke-foto.de/bilder/300x300/landschaften/15.jpg',
        'https://wernicke-foto.de/bilder/300x300/landschaften/16.jpg',
        'https://wernicke-foto.de/bilder/300x300/landschaften/17.jpg',
        'https://wernicke-foto.de/bilder/300x300/landschaften/18.jpg',
        'https://wernicke-foto.de/bilder/300x300/landschaften/19.jpg',
      ],
      previews: [
        'https://wernicke-foto.de/bilder/400x400/landschaften/01.jpg',
        'https://wernicke-foto.de/bilder/400x400/landschaften/02.jpg',
        'https://wernicke-foto.de/bilder/400x400/landschaften/03.jpg',
        'https://wernicke-foto.de/bilder/400x400/landschaften/04.jpg',
        'https://wernicke-foto.de/bilder/400x400/landschaften/05.jpg',
        'https://wernicke-foto.de/bilder/400x400/landschaften/06.jpg',
        'https://wernicke-foto.de/bilder/400x400/landschaften/07.jpg',
        'https://wernicke-foto.de/bilder/400x400/landschaften/08.jpg',
        'https://wernicke-foto.de/bilder/400x400/landschaften/09.jpg',
        'https://wernicke-foto.de/bilder/400x400/landschaften/10.jpg',
        'https://wernicke-foto.de/bilder/400x400/landschaften/11.jpg',
        'https://wernicke-foto.de/bilder/400x400/landschaften/12.jpg',
        'https://wernicke-foto.de/bilder/400x400/landschaften/13.jpg',
        'https://wernicke-foto.de/bilder/400x400/landschaften/14.jpg',
        'https://wernicke-foto.de/bilder/400x400/landschaften/15.jpg',
        'https://wernicke-foto.de/bilder/400x400/landschaften/16.jpg',
        'https://wernicke-foto.de/bilder/400x400/landschaften/17.jpg',
        'https://wernicke-foto.de/bilder/400x400/landschaften/18.jpg',
        'https://wernicke-foto.de/bilder/400x400/landschaften/19.jpg',
        ]
    },
    buildings: {
      details: [
        'https://wernicke-foto.de/bilder/original/gebaeude/01.jpg',
        'https://wernicke-foto.de/bilder/original/gebaeude/02.jpg',
        'https://wernicke-foto.de/bilder/original/gebaeude/03.jpg',
        'https://wernicke-foto.de/bilder/original/gebaeude/04.jpg',
        'https://wernicke-foto.de/bilder/original/gebaeude/05.jpg',
        'https://wernicke-foto.de/bilder/original/gebaeude/06.jpg',
        'https://wernicke-foto.de/bilder/original/gebaeude/07.jpg',
        'https://wernicke-foto.de/bilder/original/gebaeude/08.jpg',
        'https://wernicke-foto.de/bilder/original/gebaeude/09.jpg',
        'https://wernicke-foto.de/bilder/original/gebaeude/10.jpg',
        'https://wernicke-foto.de/bilder/original/gebaeude/11.jpg',
        'https://wernicke-foto.de/bilder/original/gebaeude/12.jpg',
        'https://wernicke-foto.de/bilder/original/gebaeude/13.jpg',
        'https://wernicke-foto.de/bilder/original/gebaeude/14.jpg',
        'https://wernicke-foto.de/bilder/original/gebaeude/15.jpg',
        'https://wernicke-foto.de/bilder/original/gebaeude/16.jpg',
        'https://wernicke-foto.de/bilder/original/gebaeude/17.jpg',
        'https://wernicke-foto.de/bilder/original/gebaeude/18.jpg',
        'https://wernicke-foto.de/bilder/original/gebaeude/19.jpg',
      ],
      thumbnails: [
        'https://wernicke-foto.de/bilder/300x300/gebaeude/01.jpg',
        'https://wernicke-foto.de/bilder/300x300/gebaeude/02.jpg',
        'https://wernicke-foto.de/bilder/300x300/gebaeude/03.jpg',
        'https://wernicke-foto.de/bilder/300x300/gebaeude/04.jpg',
        'https://wernicke-foto.de/bilder/300x300/gebaeude/05.jpg',
        'https://wernicke-foto.de/bilder/300x300/gebaeude/06.jpg',
        'https://wernicke-foto.de/bilder/300x300/gebaeude/07.jpg',
        'https://wernicke-foto.de/bilder/300x300/gebaeude/08.jpg',
        'https://wernicke-foto.de/bilder/300x300/gebaeude/09.jpg',
        'https://wernicke-foto.de/bilder/300x300/gebaeude/10.jpg',
        'https://wernicke-foto.de/bilder/300x300/gebaeude/11.jpg',
        'https://wernicke-foto.de/bilder/300x300/gebaeude/12.jpg',
        'https://wernicke-foto.de/bilder/300x300/gebaeude/13.jpg',
        'https://wernicke-foto.de/bilder/300x300/gebaeude/14.jpg',
        'https://wernicke-foto.de/bilder/300x300/gebaeude/15.jpg',
        'https://wernicke-foto.de/bilder/300x300/gebaeude/16.jpg',
        'https://wernicke-foto.de/bilder/300x300/gebaeude/17.jpg',
        'https://wernicke-foto.de/bilder/300x300/gebaeude/18.jpg',
        'https://wernicke-foto.de/bilder/300x300/gebaeude/19.jpg',
      ],
      previews: [
        'https://wernicke-foto.de/bilder/400x400/gebaeude/01.jpg',
        'https://wernicke-foto.de/bilder/400x400/gebaeude/02.jpg',
        'https://wernicke-foto.de/bilder/400x400/gebaeude/03.jpg',
        'https://wernicke-foto.de/bilder/400x400/gebaeude/04.jpg',
        'https://wernicke-foto.de/bilder/400x400/gebaeude/05.jpg',
        'https://wernicke-foto.de/bilder/400x400/gebaeude/06.jpg',
        'https://wernicke-foto.de/bilder/400x400/gebaeude/07.jpg',
        'https://wernicke-foto.de/bilder/400x400/gebaeude/08.jpg',
        'https://wernicke-foto.de/bilder/400x400/gebaeude/09.jpg',
        'https://wernicke-foto.de/bilder/400x400/gebaeude/10.jpg',
        'https://wernicke-foto.de/bilder/400x400/gebaeude/11.jpg',
        'https://wernicke-foto.de/bilder/400x400/gebaeude/12.jpg',
        'https://wernicke-foto.de/bilder/400x400/gebaeude/13.jpg',
        'https://wernicke-foto.de/bilder/400x400/gebaeude/14.jpg',
        'https://wernicke-foto.de/bilder/400x400/gebaeude/15.jpg',
        'https://wernicke-foto.de/bilder/400x400/gebaeude/16.jpg',
        'https://wernicke-foto.de/bilder/400x400/gebaeude/17.jpg',
        'https://wernicke-foto.de/bilder/400x400/gebaeude/18.jpg',
        'https://wernicke-foto.de/bilder/400x400/gebaeude/19.jpg',
        ]
    },
    portraits: {
      details: [
        'https://wernicke-foto.de/bilder/original/menschen/02.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/03.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/04.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/05.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/07.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/08.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/09.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/10.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/11.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/12.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/13.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/14.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/15.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/16.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/17.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/18.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/19.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/20.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/21.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/22.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/23.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/24.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/25.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/26.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/27.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/28.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/29.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/30.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/31.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/32.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/33.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/34.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/35.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/36.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/37.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/38.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/39.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/40.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/41.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/42.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/43.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/44.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/45.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/46.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/47.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/48.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/49.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/50.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/51.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/52.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/53.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/54.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/55.jpg',
        'https://wernicke-foto.de/bilder/original/menschen/56.jpg',
      ],
      thumbnails: [
        'https://wernicke-foto.de/bilder/300x300/menschen/02.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/03.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/04.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/05.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/07.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/08.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/09.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/10.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/11.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/12.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/13.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/14.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/15.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/16.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/17.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/18.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/19.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/20.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/21.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/22.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/23.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/24.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/25.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/26.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/27.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/28.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/29.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/30.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/31.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/32.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/33.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/34.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/35.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/36.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/37.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/38.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/39.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/40.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/41.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/42.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/43.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/44.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/45.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/46.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/47.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/48.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/49.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/50.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/51.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/52.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/53.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/54.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/55.jpg',
        'https://wernicke-foto.de/bilder/300x300/menschen/56.jpg',
      ],
      previews: [
        'https://wernicke-foto.de/bilder/400x400/menschen/02.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/03.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/04.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/05.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/07.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/08.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/09.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/10.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/11.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/12.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/13.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/14.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/15.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/16.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/17.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/18.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/19.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/20.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/21.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/22.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/23.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/24.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/25.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/26.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/27.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/28.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/29.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/30.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/31.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/32.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/33.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/34.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/35.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/36.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/37.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/38.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/39.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/40.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/41.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/42.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/43.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/44.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/45.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/46.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/47.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/48.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/49.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/50.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/51.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/52.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/53.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/54.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/55.jpg',
        'https://wernicke-foto.de/bilder/400x400/menschen/56.jpg',
      ]
    },
    action: {
      details: [
        'https://wernicke-foto.de/bilder/original/action/01.jpg',
        'https://wernicke-foto.de/bilder/original/action/02.jpg',
        'https://wernicke-foto.de/bilder/original/action/03.jpg',
        'https://wernicke-foto.de/bilder/original/action/04.jpg',
        'https://wernicke-foto.de/bilder/original/action/05.jpg',
        'https://wernicke-foto.de/bilder/original/action/06.jpg',
        'https://wernicke-foto.de/bilder/original/action/07.jpg',
        'https://wernicke-foto.de/bilder/original/action/08.jpg',
        'https://wernicke-foto.de/bilder/original/action/09.jpg',
        'https://wernicke-foto.de/bilder/original/action/10.jpg',
        'https://wernicke-foto.de/bilder/original/action/11.jpg',
        'https://wernicke-foto.de/bilder/original/action/12.jpg',
        'https://wernicke-foto.de/bilder/original/action/13.jpg',
        'https://wernicke-foto.de/bilder/original/action/14.jpg',
        'https://wernicke-foto.de/bilder/original/action/15.jpg',
        'https://wernicke-foto.de/bilder/original/action/16.jpg',
        'https://wernicke-foto.de/bilder/original/action/17.jpg',
        'https://wernicke-foto.de/bilder/original/action/18.jpg',
        ],
      thumbnails: [
        'https://wernicke-foto.de/bilder/300x300/action/01.jpg',
        'https://wernicke-foto.de/bilder/300x300/action/02.jpg',
        'https://wernicke-foto.de/bilder/300x300/action/03.jpg',
        'https://wernicke-foto.de/bilder/300x300/action/04.jpg',
        'https://wernicke-foto.de/bilder/300x300/action/05.jpg',
        'https://wernicke-foto.de/bilder/300x300/action/06.jpg',
        'https://wernicke-foto.de/bilder/300x300/action/07.jpg',
        'https://wernicke-foto.de/bilder/300x300/action/08.jpg',
        'https://wernicke-foto.de/bilder/300x300/action/09.jpg',
        'https://wernicke-foto.de/bilder/300x300/action/10.jpg',
        'https://wernicke-foto.de/bilder/300x300/action/11.jpg',
        'https://wernicke-foto.de/bilder/300x300/action/12.jpg',
        'https://wernicke-foto.de/bilder/300x300/action/13.jpg',
        'https://wernicke-foto.de/bilder/300x300/action/14.jpg',
        'https://wernicke-foto.de/bilder/300x300/action/15.jpg',
        'https://wernicke-foto.de/bilder/300x300/action/16.jpg',
        'https://wernicke-foto.de/bilder/300x300/action/17.jpg',
        'https://wernicke-foto.de/bilder/300x300/action/18.jpg',
      ],
      previews: [
        'https://wernicke-foto.de/bilder/400x400/action/01.jpg',
        'https://wernicke-foto.de/bilder/400x400/action/02.jpg',
        'https://wernicke-foto.de/bilder/400x400/action/03.jpg',
        'https://wernicke-foto.de/bilder/400x400/action/04.jpg',
        'https://wernicke-foto.de/bilder/400x400/action/05.jpg',
        'https://wernicke-foto.de/bilder/400x400/action/06.jpg',
        'https://wernicke-foto.de/bilder/400x400/action/07.jpg',
        'https://wernicke-foto.de/bilder/400x400/action/08.jpg',
        'https://wernicke-foto.de/bilder/400x400/action/09.jpg',
        'https://wernicke-foto.de/bilder/400x400/action/10.jpg',
        'https://wernicke-foto.de/bilder/400x400/action/11.jpg',
        'https://wernicke-foto.de/bilder/400x400/action/12.jpg',
        'https://wernicke-foto.de/bilder/400x400/action/13.jpg',
        'https://wernicke-foto.de/bilder/400x400/action/14.jpg',
        'https://wernicke-foto.de/bilder/400x400/action/15.jpg',
        'https://wernicke-foto.de/bilder/400x400/action/16.jpg',
        'https://wernicke-foto.de/bilder/400x400/action/17.jpg',
        'https://wernicke-foto.de/bilder/400x400/action/18.jpg',
        ]
    },
    tiere: {
      details: [
        'https://wernicke-foto.de/bilder/original/tiere/01.jpg',
        'https://wernicke-foto.de/bilder/original/tiere/02.jpg',
        'https://wernicke-foto.de/bilder/original/tiere/03.jpg',
        'https://wernicke-foto.de/bilder/original/tiere/04.jpg',
        'https://wernicke-foto.de/bilder/original/tiere/05.jpg',
        'https://wernicke-foto.de/bilder/original/tiere/06.jpg',
        'https://wernicke-foto.de/bilder/original/tiere/07.jpg',
        'https://wernicke-foto.de/bilder/original/tiere/08.jpg',
        'https://wernicke-foto.de/bilder/original/tiere/09.jpg',
        'https://wernicke-foto.de/bilder/original/tiere/10.jpg',
        'https://wernicke-foto.de/bilder/original/tiere/11.jpg',
        'https://wernicke-foto.de/bilder/original/tiere/12.jpg',
        'https://wernicke-foto.de/bilder/original/tiere/13.jpg',
        'https://wernicke-foto.de/bilder/original/tiere/14.jpg',
        'https://wernicke-foto.de/bilder/original/tiere/15.jpg',
        'https://wernicke-foto.de/bilder/original/tiere/16.jpg',
        'https://wernicke-foto.de/bilder/original/tiere/17.jpg',
        'https://wernicke-foto.de/bilder/original/tiere/18.jpg',
        'https://wernicke-foto.de/bilder/original/tiere/19.jpg',
        'https://wernicke-foto.de/bilder/original/tiere/20.jpg',
      ],
      thumbnails: [
        'https://wernicke-foto.de/bilder/300x300/tiere/01.jpg',
        'https://wernicke-foto.de/bilder/300x300/tiere/02.jpg',
        'https://wernicke-foto.de/bilder/300x300/tiere/03.jpg',
        'https://wernicke-foto.de/bilder/300x300/tiere/04.jpg',
        'https://wernicke-foto.de/bilder/300x300/tiere/05.jpg',
        'https://wernicke-foto.de/bilder/300x300/tiere/06.jpg',
        'https://wernicke-foto.de/bilder/300x300/tiere/07.jpg',
        'https://wernicke-foto.de/bilder/300x300/tiere/08.jpg',
        'https://wernicke-foto.de/bilder/300x300/tiere/09.jpg',
        'https://wernicke-foto.de/bilder/300x300/tiere/10.jpg',
        'https://wernicke-foto.de/bilder/300x300/tiere/11.jpg',
        'https://wernicke-foto.de/bilder/300x300/tiere/12.jpg',
        'https://wernicke-foto.de/bilder/300x300/tiere/13.jpg',
        'https://wernicke-foto.de/bilder/300x300/tiere/14.jpg',
        'https://wernicke-foto.de/bilder/300x300/tiere/15.jpg',
        'https://wernicke-foto.de/bilder/300x300/tiere/16.jpg',
        'https://wernicke-foto.de/bilder/300x300/tiere/17.jpg',
        'https://wernicke-foto.de/bilder/300x300/tiere/18.jpg',
        'https://wernicke-foto.de/bilder/300x300/tiere/19.jpg',
        'https://wernicke-foto.de/bilder/300x300/tiere/20.jpg',
      ],
      previews: [
        'https://wernicke-foto.de/bilder/400x400/tiere/01.jpg',
        'https://wernicke-foto.de/bilder/400x400/tiere/02.jpg',
        'https://wernicke-foto.de/bilder/400x400/tiere/03.jpg',
        'https://wernicke-foto.de/bilder/400x400/tiere/04.jpg',
        'https://wernicke-foto.de/bilder/400x400/tiere/05.jpg',
        'https://wernicke-foto.de/bilder/400x400/tiere/06.jpg',
        'https://wernicke-foto.de/bilder/400x400/tiere/07.jpg',
        'https://wernicke-foto.de/bilder/400x400/tiere/08.jpg',
        'https://wernicke-foto.de/bilder/400x400/tiere/09.jpg',
        'https://wernicke-foto.de/bilder/400x400/tiere/10.jpg',
        'https://wernicke-foto.de/bilder/400x400/tiere/11.jpg',
        'https://wernicke-foto.de/bilder/400x400/tiere/12.jpg',
        'https://wernicke-foto.de/bilder/400x400/tiere/13.jpg',
        'https://wernicke-foto.de/bilder/400x400/tiere/14.jpg',
        'https://wernicke-foto.de/bilder/400x400/tiere/15.jpg',
        'https://wernicke-foto.de/bilder/400x400/tiere/16.jpg',
        'https://wernicke-foto.de/bilder/400x400/tiere/17.jpg',
        'https://wernicke-foto.de/bilder/400x400/tiere/18.jpg',
        'https://wernicke-foto.de/bilder/400x400/tiere/19.jpg',
        'https://wernicke-foto.de/bilder/400x400/tiere/20.jpg',
        ]
    },
    makro: {
      details: [
        'https://wernicke-foto.de/bilder/original/makro/01.jpg',
        'https://wernicke-foto.de/bilder/original/makro/02.jpg',
        'https://wernicke-foto.de/bilder/original/makro/03.jpg',
        'https://wernicke-foto.de/bilder/original/makro/04.jpg',
        'https://wernicke-foto.de/bilder/original/makro/05.jpg',
        'https://wernicke-foto.de/bilder/original/makro/06.jpg',
        'https://wernicke-foto.de/bilder/original/makro/07.jpg',
        'https://wernicke-foto.de/bilder/original/makro/08.jpg',
        'https://wernicke-foto.de/bilder/original/makro/09.jpg',
      ],
      thumbnails: [
        'https://wernicke-foto.de/bilder/300x300/makro/01.jpg',
        'https://wernicke-foto.de/bilder/300x300/makro/02.jpg',
        'https://wernicke-foto.de/bilder/300x300/makro/03.jpg',
        'https://wernicke-foto.de/bilder/300x300/makro/04.jpg',
        'https://wernicke-foto.de/bilder/300x300/makro/05.jpg',
        'https://wernicke-foto.de/bilder/300x300/makro/06.jpg',
        'https://wernicke-foto.de/bilder/300x300/makro/07.jpg',
        'https://wernicke-foto.de/bilder/300x300/makro/08.jpg',
        'https://wernicke-foto.de/bilder/300x300/makro/09.jpg',
      ],
      previews: [
        'https://wernicke-foto.de/bilder/400x400/makro/01.jpg',
        'https://wernicke-foto.de/bilder/400x400/makro/02.jpg',
        'https://wernicke-foto.de/bilder/400x400/makro/03.jpg',
        'https://wernicke-foto.de/bilder/400x400/makro/04.jpg',
        'https://wernicke-foto.de/bilder/400x400/makro/05.jpg',
        'https://wernicke-foto.de/bilder/400x400/makro/06.jpg',
        'https://wernicke-foto.de/bilder/400x400/makro/07.jpg',
        'https://wernicke-foto.de/bilder/400x400/makro/08.jpg',
        'https://wernicke-foto.de/bilder/400x400/makro/09.jpg',
      ]
    },
    produkte: {
      details: [
        'https://wernicke-foto.de/bilder/original/produkte/01.jpg',
        'https://wernicke-foto.de/bilder/original/produkte/02.jpg',
        'https://wernicke-foto.de/bilder/original/produkte/03.jpg',
        'https://wernicke-foto.de/bilder/original/produkte/04.jpg',
        'https://wernicke-foto.de/bilder/original/produkte/05.jpg',
        'https://wernicke-foto.de/bilder/original/produkte/06.jpg',
        'https://wernicke-foto.de/bilder/original/produkte/07.jpg',
        'https://wernicke-foto.de/bilder/original/produkte/08.jpg',
        'https://wernicke-foto.de/bilder/original/produkte/09.jpg',
      ],
      thumbnails: [
        'https://wernicke-foto.de/bilder/300x300/produkte/01.jpg',
        'https://wernicke-foto.de/bilder/300x300/produkte/02.jpg',
        'https://wernicke-foto.de/bilder/300x300/produkte/03.jpg',
        'https://wernicke-foto.de/bilder/300x300/produkte/04.jpg',
        'https://wernicke-foto.de/bilder/300x300/produkte/05.jpg',
        'https://wernicke-foto.de/bilder/300x300/produkte/06.jpg',
        'https://wernicke-foto.de/bilder/300x300/produkte/07.jpg',
        'https://wernicke-foto.de/bilder/300x300/produkte/08.jpg',
        'https://wernicke-foto.de/bilder/300x300/produkte/09.jpg',
      ],
      previews: [
        'https://wernicke-foto.de/bilder/400x400/produkte/01.jpg',
        'https://wernicke-foto.de/bilder/400x400/produkte/02.jpg',
        'https://wernicke-foto.de/bilder/400x400/produkte/03.jpg',
        'https://wernicke-foto.de/bilder/400x400/produkte/04.jpg',
        'https://wernicke-foto.de/bilder/400x400/produkte/05.jpg',
        'https://wernicke-foto.de/bilder/400x400/produkte/06.jpg',
        'https://wernicke-foto.de/bilder/400x400/produkte/07.jpg',
        'https://wernicke-foto.de/bilder/400x400/produkte/08.jpg',
        'https://wernicke-foto.de/bilder/400x400/produkte/09.jpg',
      ]
    },
    lowlight: {
      details: [
        'https://wernicke-foto.de/bilder/original/lowlight/01.jpg',
        'https://wernicke-foto.de/bilder/original/lowlight/02.jpg',
        'https://wernicke-foto.de/bilder/original/lowlight/03.jpg',
        'https://wernicke-foto.de/bilder/original/lowlight/04.jpg',
        'https://wernicke-foto.de/bilder/original/lowlight/05.jpg',
        'https://wernicke-foto.de/bilder/original/lowlight/06.jpg',
        'https://wernicke-foto.de/bilder/original/lowlight/07.jpg',
        'https://wernicke-foto.de/bilder/original/lowlight/08.jpg',
      ],
      thumbnails: [
        'https://wernicke-foto.de/bilder/300x300/lowlight/01.jpg',
        'https://wernicke-foto.de/bilder/300x300/lowlight/02.jpg',
        'https://wernicke-foto.de/bilder/300x300/lowlight/03.jpg',
        'https://wernicke-foto.de/bilder/300x300/lowlight/04.jpg',
        'https://wernicke-foto.de/bilder/300x300/lowlight/05.jpg',
        'https://wernicke-foto.de/bilder/300x300/lowlight/06.jpg',
        'https://wernicke-foto.de/bilder/300x300/lowlight/07.jpg',
        'https://wernicke-foto.de/bilder/300x300/lowlight/08.jpg',
      ],
      previews: [
        'https://wernicke-foto.de/bilder/400x400/lowlight/01.jpg',
        'https://wernicke-foto.de/bilder/400x400/lowlight/02.jpg',
        'https://wernicke-foto.de/bilder/400x400/lowlight/03.jpg',
        'https://wernicke-foto.de/bilder/400x400/lowlight/04.jpg',
        'https://wernicke-foto.de/bilder/400x400/lowlight/05.jpg',
        'https://wernicke-foto.de/bilder/400x400/lowlight/06.jpg',
        'https://wernicke-foto.de/bilder/400x400/lowlight/07.jpg',
        'https://wernicke-foto.de/bilder/400x400/lowlight/08.jpg',
      ]
    },
    rooms: {
      details: [
        'https://wernicke-foto.de/bilder/original/immobilien/01.jpg',
        'https://wernicke-foto.de/bilder/original/immobilien/02.jpg',
        'https://wernicke-foto.de/bilder/original/immobilien/03.jpg',
        'https://wernicke-foto.de/bilder/original/immobilien/04.jpg',
        'https://wernicke-foto.de/bilder/original/immobilien/05.jpg',
        'https://wernicke-foto.de/bilder/original/immobilien/06.jpg',
        'https://wernicke-foto.de/bilder/original/immobilien/07.jpg',
        'https://wernicke-foto.de/bilder/original/immobilien/08.jpg',
      ],
      thumbnails: [
        'https://wernicke-foto.de/bilder/300x300/immobilien/01.jpg',
        'https://wernicke-foto.de/bilder/300x300/immobilien/02.jpg',
        'https://wernicke-foto.de/bilder/300x300/immobilien/03.jpg',
        'https://wernicke-foto.de/bilder/300x300/immobilien/04.jpg',
        'https://wernicke-foto.de/bilder/300x300/immobilien/05.jpg',
        'https://wernicke-foto.de/bilder/300x300/immobilien/06.jpg',
        'https://wernicke-foto.de/bilder/300x300/immobilien/07.jpg',
        'https://wernicke-foto.de/bilder/300x300/immobilien/08.jpg',
      ],
      previews: [
        'https://wernicke-foto.de/bilder/400x400/immobilien/01.jpg',
        'https://wernicke-foto.de/bilder/400x400/immobilien/02.jpg',
        'https://wernicke-foto.de/bilder/400x400/immobilien/03.jpg',
        'https://wernicke-foto.de/bilder/400x400/immobilien/04.jpg',
        'https://wernicke-foto.de/bilder/400x400/immobilien/05.jpg',
        'https://wernicke-foto.de/bilder/400x400/immobilien/06.jpg',
        'https://wernicke-foto.de/bilder/400x400/immobilien/07.jpg',
        'https://wernicke-foto.de/bilder/400x400/immobilien/08.jpg',
      ]
    },
    babies: {
      details: [
        'https://wernicke-foto.de/bilder/original/babys/01.jpg',
        'https://wernicke-foto.de/bilder/original/babys/02.jpg',
        'https://wernicke-foto.de/bilder/original/babys/03.jpg',
        'https://wernicke-foto.de/bilder/original/babys/04.jpg',
        'https://wernicke-foto.de/bilder/original/babys/05.jpg',
        'https://wernicke-foto.de/bilder/original/babys/06.jpg',
        'https://wernicke-foto.de/bilder/original/babys/07.jpg',
        'https://wernicke-foto.de/bilder/original/babys/08.jpg',
        'https://wernicke-foto.de/bilder/original/babys/10.jpg',
      ],
      thumbnails: [
        'https://wernicke-foto.de/bilder/300x300/babys/01.jpg',
        'https://wernicke-foto.de/bilder/300x300/babys/02.jpg',
        'https://wernicke-foto.de/bilder/300x300/babys/03.jpg',
        'https://wernicke-foto.de/bilder/300x300/babys/04.jpg',
        'https://wernicke-foto.de/bilder/300x300/babys/05.jpg',
        'https://wernicke-foto.de/bilder/300x300/babys/06.jpg',
        'https://wernicke-foto.de/bilder/300x300/babys/07.jpg',
        'https://wernicke-foto.de/bilder/300x300/babys/08.jpg',
        'https://wernicke-foto.de/bilder/300x300/babys/10.jpg',
      ],
      previews: [
        'https://wernicke-foto.de/bilder/400x400/babys/01.jpg',
        'https://wernicke-foto.de/bilder/400x400/babys/02.jpg',
        'https://wernicke-foto.de/bilder/400x400/babys/03.jpg',
        'https://wernicke-foto.de/bilder/400x400/babys/04.jpg',
        'https://wernicke-foto.de/bilder/400x400/babys/05.jpg',
        'https://wernicke-foto.de/bilder/400x400/babys/06.jpg',
        'https://wernicke-foto.de/bilder/400x400/babys/07.jpg',
        'https://wernicke-foto.de/bilder/400x400/babys/08.jpg',
        'https://wernicke-foto.de/bilder/400x400/babys/10.jpg',
      ]
    }
  },
  actions: {},
  getters: {
    categories: state => state.categories,
    akt: state => state.akt,
    hochzeiten: state => state.hochzeiten,
    landschaften: state => state.landschaften,
    buildings: state => state.buildings,
    portraits: state => state.portraits,
    action: state => state.action,
    tiere: state => state.tiere,
    makro: state => state.makro,
    produkte: state => state.produkte,
    lowlight: state => state.lowlight,
    rooms: state => state.rooms
  },
})